import * as Yup from "yup";

export const dateValueRegex = /^(?:\d+[ymwd])?$/;
export const timeValueRegex = /^(?:\d+[HMS])?$/;
export const datetimeValueRegex = /^(?:\d+[ymwdHMS])?$/;

export const formConditionValidation = (translate, includeMessage) =>
    Yup.array().of(
        Yup.array().of(
            Yup.object({
                section: Yup.string()
                    .nullable()
                    .required(translate("OTM_SECTION_REQUIRED")),
                item: Yup.string()
                    .nullable()
                    .required(translate("OTM_ITEM_REQUIRED")),
                operation: Yup.string().required(
                    translate("OTM_OPERATION_REQUIRED")
                ),
                value: Yup.string().when(
                    ["operation", "timeFrame", "relativeValue", "dataType"],
                    (operation, timeFrame, relativeValue, dataType) => {
                        if (operation === 'is-set' || operation === 'is-unset') {
                            return Yup.string().nullable();
                        }
                        // If relative value is false then we expect something in 'value' field
                        if (relativeValue.toString() === "false") {
                            // If timeFrame is set to relative date we have specific 'value' format to check
                            if (timeFrame === "relative-date") {
                                if (dataType === "date") {
                                    return Yup.string()
                                        .matches(
                                            dateValueRegex,
                                            translate("OTM_FIELD_VALUE_INVALID")
                                        )
                                        .required(
                                            translate("OTM_VALUE_REQUIRED")
                                        );
                                } else if (dataType === "time") {
                                    return Yup.string()
                                        .matches(
                                            timeValueRegex,
                                            translate("OTM_FIELD_VALUE_INVALID")
                                        )
                                        .required(
                                            translate("OTM_VALUE_REQUIRED")
                                        );
                                }
                                return Yup.string()
                                    .matches(
                                        datetimeValueRegex,
                                        translate("OTM_FIELD_VALUE_INVALID")
                                    )
                                    .required(translate("OTM_VALUE_REQUIRED"));
                            }
                            // If the timeFrame is now then we don't require 'value'
                            if (timeFrame === "now") {
                                return Yup.string();
                            }

                            return Yup.string().required(
                                translate("OTM_VALUE_REQUIRED")
                            );
                        }
                    }
                ),
                relativeTimePeriod: Yup.string().when(
                    "timeFrame",
                    (timeFrame) => {
                        if (timeFrame === "relative-date") {
                            return Yup.string().required(
                                translate("OTM_RELATIVE_TIME_PERIOD_REQUIRED")
                            );
                        }
                    }
                ),
                relativeValue: Yup.string().required(
                    translate("OTM_RELATIVE_VALUE_REQUIRED")
                ),
                relativeSection: Yup.string()
                    .nullable()
                    .when("relativeValue", (relativeValue) => {
                        if (relativeValue?.toString() === "true") {
                            return Yup.string()
                                .nullable()
                                .required(
                                    translate("OTM_RELATIVE_SECTION_REQUIRED")
                                );
                        }
                    }),
                relativeItem: Yup.string()
                    .nullable()
                    .when("relativeValue", (relativeValue) => {
                        if (relativeValue?.toString() === "true") {
                            return Yup.string()
                                .nullable()
                                .required(
                                    translate("OTM_RELATIVE_ITEM_REQUIRED")
                                );
                        }
                    }),
                message:
                    includeMessage === true
                        ? Yup.string()
                            .nullable()
                            .required(translate("OTM_MESSAGE_REQUIRED"))
                        : Yup.string()
            })
        )
    );

export const conditionKeys = [
    "section",
    "item",
    "operation",
    "timeFrame",
    "relativeTimePeriod",
    "relativeValue",
    "relativeSection",
    "relativeItem",
    "value"
];

export const removeTouchedProps = (props, values) => {
    props.forEach((prop) => {
        values[prop].forEach((orCondition) => {
            orCondition.forEach((andCondition) => {
                for (const field in andCondition) {
                    if (field.substring(0, 9) === "_touched_") {
                        delete (andCondition[field]);
                    }
                }
            });
        });
    });
};
